import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { RmsUtilsService, TextContentService } from '../../../../core/services';
import { InsightsService } from '../../../../core/data-services/insights.service';
import { BannerNotificationsService } from '../../../../xform-compat';

@Component({
    selector: 'rms-text-content-associated-map-modal',
    templateUrl: './text-content-associated-map-modal.component.html',
    styleUrls: ['./text-content-associated-map-modal.component.scss'],
    standalone: false
})
export class TextContentAssociatedMapModalComponent implements OnDestroy, OnInit {
  @ViewChild('associatedMapModal', { static: true }) modal: ElementRef;
  @Input() data: any;
  @Output() itemPosted: EventEmitter<any> = new EventEmitter<any>();
  private modalReference: NgbModalRef;
  private modalSubscription: Subscription;
  public associatedMapAssigned: Array<any>;
  public associatedMapList: Array<{id: number, name: string, isKey: boolean}> = [];
  public newAssociatedMap: any;
  public newAssociatedMapKey: boolean;
  public originalData: Array<any>;
  public totalAssociatedMap: number;

  constructor(
    private bannerNotificationService: BannerNotificationsService,
    private insightsService: InsightsService,
    private modalService: NgbModal,
    private textContentService: TextContentService
  ) {
    this.associatedMapAssigned = [];
    this.newAssociatedMap = {};
    this.newAssociatedMapKey = false;
    this.originalData = [];
    this.totalAssociatedMap = 0;
  }

  ngOnInit() {
    this.modalSubscription = this.textContentService.openAssociatedMapModal$.subscribe((id) => {
      if ( id === this.data.id ) {
        this.getMapList();
        this.modalReference = this.modalService.open(this.modal, {size: 'lg'});
        this.modalReference.result.then(
          () => this.resetForm(),
          () => this.resetForm()
        );
        if ( this.data.textContent.maps ) {
          this.associatedMapAssigned = this.data.textContent.maps;
          this.totalAssociatedMap = this.associatedMapAssigned.length;
          this.originalData = RmsUtilsService.deepClone(this.associatedMapAssigned);
        }
      }
    });
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  /**
   * Removes the map item from the array
   * @param index
   */
  public removeAssociatedMap(index): void {
    this.associatedMapAssigned.splice(index, 1);
  }

  /**
   * Gets the data to fill the Map List select
   */
  private getMapList(): void {
    this.insightsService.getInsightsMaps().subscribe(
      value => {
        this.associatedMapList = value.records;
      },
      error1 => this.bannerNotificationService.error(error1)
    );
  }


  /**
   * Resets the form
   */
  public resetForm(): void {
    this.data.textContent.maps = this.originalData;
    this.totalAssociatedMap = this.data.textContent.maps.length;
  }

  /**
   * Adds the map object to the array
   */
  public  addAssociatedMap(): void {
    if ( !this.newAssociatedMap.id ) {
      return;
    }
    this.associatedMapAssigned.push({id: this.newAssociatedMap.id, name: this.newAssociatedMap.name, isKey: this.newAssociatedMapKey});
    this.newAssociatedMap = '';
    this.newAssociatedMapKey = false;
  }

  /**
   * Process the form for submit
   */
  public processForm(): void {
    const params = { maps: [] };
    const equals = RmsUtilsService.isEqual(this.associatedMapAssigned, this.originalData);
    if ( equals ) {
      this.bannerNotificationService.error('Please add or remove an Associated Map');
      return;
    }
    this.originalData = RmsUtilsService.deepClone(this.associatedMapAssigned);
    this.associatedMapAssigned.forEach( item => {
      params.maps.push({mapId: item.id, isKey: item.isKey});
    });
    this.insightsService.postInsightsMaps(this.data.id, params).subscribe(
      value => {
        this.associatedMapList = value.records;
        this.bannerNotificationService.success('Associated Maps Added Successfully');
        this.modalReference.close();
      },
      error1 => this.bannerNotificationService.error(error1)
    );
  }

  /**
   * Checks the list of selected items agains the available, to avoid duplicate entries
   */
  public isAlreadySelected( value: number ): boolean {
    for ( let i = 0; i < this.associatedMapAssigned.length; i++ ) {
      if ( this.associatedMapAssigned[i]['id'] === value ) {
        return true;
      }
    }
    return false;
  }

}
